export const welcomePageVideo =
  'https://player.vimeo.com/external/371489127.sd.mp4?s=fd49004fc4fe778225f9f599342182e106dc32c1&profile_id=164&oauth2_token_id'
